import { render } from "./BookClass.vue?vue&type=template&id=7762ff0c"
import script from "./BookClass.vue?vue&type=script&lang=js"
export * from "./BookClass.vue?vue&type=script&lang=js"

import "./BookClass.vue?vue&type=style&index=0&id=7762ff0c&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__